var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes }, [_vm._m(0)])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "table",
      {
        ref: "table",
        class: _vm.className,
        attrs: { id: _vm.tableId, cellpadding: "0" }
      },
      [
        _c("thead", { staticClass: "thead-dark" }, [
          _c(
            "tr",
            _vm._l(_vm.options.columns, function(field, i) {
              return _c(
                "th",
                { key: i, class: field.className },
                [
                  _vm._t(
                    "HEAD_" + field.name,
                    [
                      _c("div", {
                        domProps: { innerHTML: _vm._s(field.title) }
                      })
                    ],
                    { field: field, i: i }
                  )
                ],
                2
              )
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c("tbody"),
        _vm._v(" "),
        _c("tfoot", { attrs: { id: "footR" } })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6eab2c2e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eab2c2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/table/productsTable.vue
// module id = null
// module chunks = 